import React, { useMemo } from "react";
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid } from "@mui/material";
import { debounce } from '@mui/material/utils';
import searchServices from '../../services/search-sevices/search-services'
import IconButton from '@mui/material/IconButton';
import NextPlanIcon from '@mui/icons-material/NextPlan';
import stylesConfig from '../../theme/config';
import { styled, lighten, darken } from '@mui/system';

const OverideHotSearchAndCopy: React.FC<any> = (
 {
   index, 
   row,
   isChecked,
   hotWord,
   handleCopyClick,
   checkboxOnChange,
   handleAsyncHotWordToParentByIndex, // remove hot word in parent by index
   isLastItem
 }
) => {

  const [checked, setChecked] = React.useState<boolean>(false);
  const [value, setValue] = React.useState(hotWord || null);
  // const [inputValue, setInputValue] = React.useState(hotWord);
  const [options, setOptions] = React.useState<any>([]);
  const loaded = React.useRef(false);


  const globalSearchProductsHandler = async (word: string) => {
    try {
      // const response = await searchServices.getSearchProductByNameOrAliasPaginated(word);
      //includes exchange
      const searchResponse =  await searchServices.hotSearchWithProductAndExchange(word);
      
      //console.log(searchData);

      if(!searchResponse) return;

      const productResults = searchResponse.products;
      const exchangeResults = searchResponse.exchanges;

      //console.log(productResults);
      //console.log(exchangeResults);

      const response = [...productResults, ...exchangeResults]

      //console.log(response);
      
      if(!response)return;
      const isArrayRes = Array.isArray(response)
      if(!isArrayRes && response['name'] === word)return;

      setOptions(response.map(r=>{//set into option object
          return  Object.keys(r).includes('id') ?
                    { label:  `${r.vname } >> ${r.name}`,
                        productId: r.id,
                        vendorId: r.vendorID,
                        productName: r.name,
                        vendorName: r.vname,
                        group:'Products',
                        isExchange: false,
                    } 
                    :
                    {
                        label:  `${r.vendorname } >> ${r.exchangename}`,
                        productId: r.euid,
                        vendorId: r.vuid,
                        productName: r.exchangename,
                        vendorName: r.vendorname,
                        group:'Exchanges',
                        isExchange: true,
                    }
        }) 
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const searchDelayed = useMemo(
    () => debounce( globalSearchProductsHandler, 500),
    []
);
React.useEffect(()=>{//copy hot word from above row
    if(hotWord === undefined) return;
    setOptions([])//empty options
    setValue(hotWord)
},[hotWord])

React.useEffect(()=>{
    setChecked(isChecked)// effect on local checkbox 
},[isChecked])


  const onCheckboxChange = (index : number)=>{
    setOptions([])
    checkboxOnChange(index)
  }

  const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    backgroundColor:
      theme.palette.mode === 'light'
        ? lighten(theme.palette.primary.light, 0.85)
        : darken(theme.palette.primary.main, 0.8),
  }));
  
  const GroupItems = styled('ul')({
    padding: 0,
  });

  return (
    <Grid container spacing={2} wrap='nowrap'>
        {/* <div>{`value: ${value !== null ? `'${value}'` : 'null'}`}</div>
      <div>{`inputValue: '${inputValue}'`}</div>
      <div>{`hotWord: '${hotWord}'`}</div>
      <div>{`isChecked: '${isChecked}'`}</div> */}
        <Checkbox
                checked={isChecked || false}
                onChange={() => onCheckboxChange(index)}
                inputProps={{ 'aria-label': 'controlled' }}
                // labelStyle={{color: stylesConfig.tiles.govTile}}
                //   iconStyle={{fill: stylesConfig.tiles.govTile}}
                //   inputStyle={{color:stylesConfig.tiles.govTile}}
                  style={{color:stylesConfig.tiles.govTile}}
                  size="small" 

        />
        <Autocomplete
                defaultValue={value || null}
                disablePortal
                id={"combo-box-demo_"+index}
                disabled={!checked}
                filterOptions={(x) => x}
                options={options}
                sx={{ width: 300 }}
                filterSelectedOptions
                value={value}
                noOptionsText="Search using a Service Name"
                onChange={(event: any, newValue) => {
                  // console.log('onChange', newValue, options)
                  setValue(newValue);
                  handleAsyncHotWordToParentByIndex(index, newValue)
                }}
                onInputChange={(event, newInputValue) => {
                    // console.log('onInputChange', newInputValue, value, options)
                    //check empty or this input copy from hotword, return.
                    if(!newInputValue || newInputValue === hotWord)return;
                    searchDelayed(newInputValue)
                }}
             
                groupBy={(option) => option.group}
                renderGroup={(params) => {
                   //console.log('renderGroup', params)
                      return(
                      <li>
                          <GroupHeader>{params.group}</GroupHeader>
                          <GroupItems>{params.children}</GroupItems>
                      </li>
                    )
                    }}  
                    renderInput={(params) => (
                      <TextField {...params} placeholder={"Search using a Service Name"} />
                      )}
            />
        {!isLastItem && <IconButton 
              aria-label="copy to next row" 
              disabled={false}
              onClick={()=>handleCopyClick(value, index)}   
              sx={{color: stylesConfig.tiles.govTile}}
            >
            <NextPlanIcon  fontSize="large"/>
          </IconButton>
        }
</Grid>
  );
};

export default OverideHotSearchAndCopy;
